import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getScenarioCostFacilityDetail = api(async function scenarioCostFacilityDetail({
    scenarioId,
    variantId,
    setKey,
    facilityId,
}) {
    return query(
        gql`
            query GetScenarioCostFacilityDetail(
                $scenarioId: String!
                $variantId: String!
                $setKey: String!
                $facilityId: String!
            ) {
                scenarioCostFacilityDetail(
                    scenarioId: $scenarioId
                    variantId: $variantId
                    setKey: $setKey
                    facilityId: $facilityId
                ) {
                    facilityId
                    taskCount
                    annualHours
                    annualCost
                    byClassification {
                        label
                        taskCount
                        annualHours
                        annualCost
                    }
                    byFrequency {
                        label
                        taskCount
                        annualHours
                        annualCost
                    }
                }
            }
        `,
        { scenarioId, variantId, setKey, facilityId },
        { returns: "scenarioCostFacilityDetail" }
    )
})
